export default {
    GET_COMPARE_REPORT_LIST: '/api/v1/report-compare/items',
    GET_PREVIEW_REPORT_ORDER_AND_CART_SEQ: '/api/v1/report-compare/order-item',
}